import { render, staticRenderFns } from "./NavbarPublic.vue?vue&type=template&id=489ea25c"
import script from "./NavbarPublic.vue?vue&type=script&lang=js"
export * from "./NavbarPublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports